import { get } from '../../api';

export const getUnidadesClienteSelect = async (idCliente) => {
  const res = await get(`/api/clientes/${idCliente}/unidades`);

  return res.map((item) => ({
    key: item.id,
    value: item.id,
    title: `${item.nm} - ${item.id}`,
  }));
};
